import React from 'react'
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom'

import { AuthRoute } from '../../common/components/routes'
import { Page } from '../../common/components/sections'
import { APP_ROUTES } from '../../common/constants'

import { AccountRouter } from '../../account/components'
import { AllergensRouter } from '../../allergens/components'
import { AwardsRouter } from '../../awards/components'
import { ChallengesRouter } from '../../challenges/components'
import { CourseTypesRouter } from '../../course-types/components'
import { CuisineTypesRouter } from '../../cuisine-types/components'
import { DictionaryWordsRouter } from '../../dictionary-words/components'
import { DietCategoriesRouter, DietsRouter } from '../../diets/components'
import { DishTypesRouter } from '../../dish-types/components'
import { FoodMoodsRouter } from '../../food-moods/components'
import { IngredientsRouter } from '../../ingredients/components'
import {
  LocationTypeCategoriesRouter,
  LocationTypesRouter,
} from '../../location-types/components'
import { ReportsRouter } from '../../reports/components'
import { UsersRouter } from '../../users/components'

const MainRouter = () => (
  <BrowserRouter>
    <Switch>
      <Route path={APP_ROUTES.ACCOUNT.link} component={AccountRouter} />
      <Page>
        <AuthRoute
          path={APP_ROUTES.OTHER.subMenuItems.USERS.link}
          component={UsersRouter}
        />
        <AuthRoute
          path={APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.CHALLENGES.link}
          component={ChallengesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.MOBILE_APP_ONLY.subMenuItems.FOOD_MOODS.link}
          component={FoodMoodsRouter}
        />
        <AuthRoute
          path={APP_ROUTES.ALLERGENS.link}
          component={AllergensRouter}
        />
        <AuthRoute
          path={APP_ROUTES.INGREDIENTS.link}
          component={IngredientsRouter}
        />
        <AuthRoute path={APP_ROUTES.DIETS.link} component={DietsRouter} />
        <AuthRoute
          path={APP_ROUTES.DIET_CATEGORIES.link}
          component={DietCategoriesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.DISH_TYPES.link}
          component={DishTypesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.COURSE_TYPES.link}
          component={CourseTypesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.CUISINE_TYPES.link}
          component={CuisineTypesRouter}
        />
        <AuthRoute path={APP_ROUTES.AWARDS.link} component={AwardsRouter} />
        <AuthRoute
          path={APP_ROUTES.LOCATION_TYPE_CATEGORIES.link}
          component={LocationTypeCategoriesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.LOCATION_TYPES.link}
          component={LocationTypesRouter}
        />
        <AuthRoute
          path={APP_ROUTES.DICTIONARY_WORDS.link}
          component={DictionaryWordsRouter}
        />
        <AuthRoute
          path={APP_ROUTES.OTHER.subMenuItems.REPORTS.link}
          component={ReportsRouter}
        />
      </Page>
      <Redirect
        exact
        from={APP_ROUTES.ROOT.link}
        to={APP_ROUTES.INGREDIENTS.link}
      />
    </Switch>
  </BrowserRouter>
)

export default MainRouter
